import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGrid$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGrid extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2eb5102036811d034c4eb853d902f942aa515e84', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ca2cb725e23672661ea352f2e92ee23d59506466', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '50770d89772824bde5c65a44c17417e8070b2dbc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 5.667A1.333 1.333 0 1 0 11 3a1.333 1.333 0 0 0 0 2.667M12.333 11a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0m0 6.667a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0m-6.666 0a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0m-1.334-5.334a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666m1.334-8a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0m12 8a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666m1.333-8a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M17.667 19a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-grid", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-grid"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-grid":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGrid$1);
            }
            break;
    } });
}

const CosmosIconGrid = CosmosIconGrid$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGrid, defineCustomElement };
